const data = [
  {
    id: 1,
    image: "images/d-9887.png",
    title: "All Designs",
    link: "https://supriya101.github.io/designs/"
  },
  {
    id: 2,
    image: "images/d-3.png",
    title: "Konfhub UI Design 1 (Figma)",
    link: "https://www.figma.com/file/9tglacFvbLmhP7DxSPWtOQ/KONFHUB-LANDING-PAGE?type=design&node-id=0%3A1&mode=design&t=B1okgqp8VCj6xcjJ-1"
  },
  {
      id: 3,
      image: "images/d-1.png",
      image2: "images/d-2.png",
      title: "Konfhub UI Design 2 (Figma)",
      link:"https://www.figma.com/file/6Y4QQ2n8XpQWuylXFF0wag/KONFHUB-SMS-DESIGN?type=design&mode=design&t=B1okgqp8VCj6xcjJ-1"
    },
   
  ]
  export default data